import { FC } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppItem } from '../AppAccessSidepanel';

type AppAccessGamesListDialogProps = {
  open: boolean;
  onClose: () => void;
  companyName: string;
  games: AppItem[];
};

const GameRow: FC<{ game: AppItem }> = ({ game }) => (
  <>
    <Box
      sx={{
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: '#162936',
        justifySelf: 'center',
      }}
    />
    <Typography fontSize={12} fontWeight={500} sx={{ lineHeight: 1.2, whiteSpace: 'nowrap' }}>
      {game.gameId}
    </Typography>
    <Typography
      fontSize={14}
      fontWeight={500}
      sx={{ color: '#162936', lineHeight: 1.2, minWidth: 0, ml: 1 }}
    >
      {game.name}
    </Typography>
  </>
);

const AppAccessGamesListDialog: FC<AppAccessGamesListDialogProps> = ({
  open,
  onClose,
  companyName,
  games,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: isMobile ? '100%' : '560px',
          borderRadius: '16px',
          padding: '24px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 1,
          p: 0,
          fontSize: '1.25rem',
          fontWeight: 700,
          color: '#162936',
          fontFamily: 'Manrope, sans-serif',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {`Company: ${companyName}`}
          <Typography
            fontSize={14}
            fontWeight={500}
            sx={{ color: '#6C6C6C', lineHeight: '1.25rem' }}
          >
            Showing all games
          </Typography>
        </Box>
        <IconButton aria-label="Close" onClick={onClose} size="small" sx={{ mt: '-4px' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, mt: 2 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `8px max-content minmax(0, 1fr)`,
            columnGap: '12px',
            rowGap: '16px',
            alignItems: 'center',
            maxHeight: isMobile ? '100%' : '350px',
            overflow: 'auto',
            backgroundColor: '#F0F0F1',
            padding: '12px',
            borderRadius: '8px',
          }}
        >
          {games.map((game) => (
            <GameRow key={game.id} game={game} />
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AppAccessGamesListDialog;
